import { render, staticRenderFns } from "./GeneralSettingsEMS.vue?vue&type=template&id=55ccf3ec&scoped=true&"
import script from "./GeneralSettingsEMS.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsEMS.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralSettingsEMS.vue?vue&type=style&index=0&id=55ccf3ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ccf3ec",
  null
  
)

export default component.exports